<div class="{{ modalFullpage }} modal-container {{ modalDisplay }}">
  <div class="modal-container{{ size }} {{ extraClasses }}">
    <div class="modal-container__dismiss-row" *ngIf="showClose">
      <button class="modal-container__button-close" (click)="deactivate()">
        <icon type="close"></icon>
      </button>
    </div>
    <div class="modal-container{{ body }}">
      <ng-container #childModalRef></ng-container>
    </div>
  </div>
</div>
